import React, { Fragment } from 'react';
import { Table, Button, Modal } from 'antd';
import { connect } from 'dva';
import _cloneDeep from 'lodash/cloneDeep';
import Address from 'components_business/Address/Index.js';
import { groupTypeMapArr } from 'utils/enum/state-enum.js';
import styles from './Index.less';
import AlertInfo from './AlertInfoCard.js';

@connect(({ operationChargeItemPublishChargeItemSteps }) => ({
  publishSchool: operationChargeItemPublishChargeItemSteps.publishSchool,
  addressBook: operationChargeItemPublishChargeItemSteps.addressBook,
}))
export default class AddressListTable extends React.Component {
  constructor(props) {
    super(props);

    this.handleOk = this.handleOk.bind(this);
  }

  handleOk({ userList }) {
    const { addressBook: { tableList } } = this.props;
    let resultList = [];

    // 人员去重
    tableList.forEach(item => {
      const result = userList.some(newItem => newItem.id === item.id);

      if (!result) {
        resultList.push(item);
      }
    });

    resultList = resultList.concat(userList);

    this.props.dispatch({
      type: 'operationChargeItemPublishChargeItemSteps/setAddressBook',
      payload: {
        tableList: resultList,
      },
    });
  }

  // 调起通讯录组件
  handleAdd = () => {
    const { publishSchool: { key } } = this.props;
    this.props.dispatch({
      type: 'AddressBook/saveOrgId',
      orgId: key,
    });

    this.props.dispatch({
      type: 'AddressBook/setChargeTarget',
      payload: {
        visible: true,
        addressBook: [],
        selected: [],
        defaultCheckedKey: [],
        schoolName: '',
        exceptNodes: {},
      },
    });
  };

  handleDelete = rowData => {
    Modal.confirm({
      title: '确认删除？',
      onOk: () => {
        const { id } = rowData;
        const { addressBook: { tableList } } = this.props;
        const cloneTableList = _cloneDeep(tableList);

        cloneTableList.some((item, index, arr) => {
          if (item.id === id) {
            arr.splice(index, 1);
          }
          return item.id === id;
        });

        this.props.dispatch({
          type: 'operationChargeItemPublishChargeItemSteps/setAddressBook',
          payload: {
            tableList: cloneTableList,
          },
        });
      },
    });
  };

  render() {
    const { addressBook: { tableList } } = this.props;
    const columns = [
      {
        title: '学校/校区',
        dataIndex: 'schoolName',
      },
      {
        title: '分组',
        dataIndex: 'groupType',
        render: val => {
          const status = groupTypeMapArr.find(q => q.key === val);
          return status ? status.value : val;
        },
      },
      {
        title: '年级/部门',
        dataIndex: 'lastDepartName',
      },
      {
        title: '班级/部门',
        dataIndex: 'curDepartName',
      },
      {
        title: '姓名',
        dataIndex: 'name',
      },
      {
        title: '操作',
        render: rowData => {
          return (
            <Fragment>
              <a onClick={this.handleDelete.bind(this, rowData)}>删除</a>
            </Fragment>
          );
        },
      },
    ];

    return (
      <div className={styles.root}>
        <div className="table-operation-buttons-wraps">
          <Button type="primary" onClick={this.handleAdd.bind(this)}>
            从通讯录中选择
          </Button>
        </div>
        <AlertInfo userList={tableList} />
        <Table rowKey="id" dataSource={tableList} columns={columns} pagination={20} />
        <Address renderContent="tree" onOk={this.handleOk} />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/Operation/ChargeItem/PublishChargeItemSteps/Step3-Notification/AddressList/Index.js